<!-- <div class="fluid-container">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title p-0">
            <h5 class="mb-0">Review I-140 Petition</h5>
            <p class="mb-0" style="font-size:14px">Generate Draft Petition & Notify the reviewer</p>
        </div>

        <div class="col-md-4 editBtn headerSubPortion px-0">
            <ul>
                <li class="col-auto px-0 firstPortion">
                    <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
                </li>
                <li class="col-auto pr-0 pl-2 secondPortion">
                    <lib-maximize-dialog-library
                        [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
                    <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 p-0">
            <lib-assigning-task-library [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-tabView styleClass="review-petition-tab-view">
        <p-tabPanel header="Update/Generate Draft Petition" *ngIf="shouldLoadTab">
            <div class="pt-3">
                <app-i140-review-petiton-new [disabledControls]="disabledControls"
                    [primaryData]="this.dynamicDialogConfig.data"></app-i140-review-petiton-new>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Reviewer Info & Feedback" *ngxPermissionsOnly="['PETITION_REVIEWER']">
            <span class="review-info-title">"Review Status" or "Submit for Review"</span>
            <div class="petition-analysis-holder">
                <div class="row">
                    <div class="col-12 pl-0 mb-3">
                        <span class="review-info-sub-title">Reviwer Details</span>
                    </div>
                    <div class="col-12 pl-0 mb-2">
                        <p class="review-info-text mb-0">Note: Reviewer details can be updated after previous step is
                            marked complete</p>
                    </div>
                </div>
                <div class="col-12 pl-0 mt-4 mb-3">
                    <span class="review-info-sub-title">Add Comments</span>
                </div>
                <div class="col-md-12 p-0">
                    <label>Add Comments / Notes</label>
                </div>
                <div class="col-md-4 p-0 processing-dropdown">
                    <label class="required">Review </label>
                </div>
                <div class="col-md-7 p-0 pt-3">
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div> -->
<!-- ------------------------------------------------------ -->
<div class="fluid-container">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title p-0">
            <h5 class="mb-0">Review I-140 Petition</h5>
            <p class="mb-0" style="font-size:14px">Generate Draft Petition & Notify the reviewer</p>
        </div>

        <div class="col-md-4 editBtn headerSubPortion px-0">
            <ul>
                <li class="col-auto px-0 firstPortion">
                    <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
                </li>
                <li class="col-auto pr-0 pl-2 secondPortion">
                    <lib-maximize-dialog-library
                        [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
                    <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 p-0">
            <lib-assigning-task-library [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="main-body no-footer">
        <form #printReviewForm="ngForm">
            <div class="pd-0 generate-btn" *ngxPermissionsOnly="['EDIT_PETITION']">
                <!-- this block will be toggled based on printPetitionBlock -->
                <div *ngIf="!printPetitionBlock">
                    <div class="row mb-2 mt-4">
                        <div class="col">
                            <h5>Generate Draft PDF</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="row control-lbl">Click on the ‘Generate’ button to view the Draft Petition
                                PDF</label>
                            <button type="button" pButton (click)="generatePetition(true)" [disabled]="disabledControls"
                                class="btn btn-primary mt-1">
                                Generate Draft Petition
                            </button>
                        </div>
                        <div class="col" *ngIf="enableViewDraftButton">
                            <div class="divider-right"></div>
                            <label class="row control-lbl">Print generated on {{draftGeneratedDate}}
                            </label>
                            <button (click)="viewPetitionDraft(draftPDFPath)" class="btn btn-primary mt-1">
                                View Draft Petition
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngxPermissionsExcept="['PETITION_REVIEWER']">
                    <div class="row mt-4">
                        <div class="col-md-12 add-comments">
                            <h5>Reviewer Details</h5>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-end">
                        <div class="col-4 form-group processing-dropdown">
                            <label class="label-cls row required">Reviewer Name</label>
                            <p-dropdown [options]="users" name="reviewerId" [(ngModel)]="reviewerdata.id"
                                [disabled]="disabledControls" optionLabel="firstName" optionValue="id"
                                placeholder="select" #reviewerId="ngModel" (onChange)="userSelected($event)">
                                <ng-template pTemplate="selectedItem">
                                    <div *ngIf="reviewerdata.id">
                                        <div>{{reviewerdata.reviewerName}}</div>
                                    </div>
                                </ng-template>
                                <ng-template let-reviewer pTemplate="item">
                                    <div>
                                        <div>{{reviewer?.firstName +' ' +reviewer?.lastName}}</div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                        <div class="col-3 form-group">
                            <label class="label-cls row required">Designation</label>
                            <div class="Wrapper">
                                <input class="im-input mw-100" name="reviewerDesignation" pInputText
                                    [(ngModel)]="reviewerdata.reviewerDesignation" type="text"
                                    #reviewerDesignation="ngModel" required readOnly />
                            </div>
                        </div>
                        <div class="col-2 form-group">
                            <button pButton type="submit" label="Update"
                                [ngClass]="printReviewForm.form.invalid  || disabledControls ? 'btn-success  mr-3 btn-success_disabled':'btn-success mr-3'"
                                (click)="saveReviewerDetails()"
                                [disabled]="printReviewForm.invalid || disabledControls">
                            </button>
                        </div>
                        <div class="col-3 form-group" *ngIf="notiferReviewer || reviewerdata.id">
                            <button pButton type="submit" label="Notify Reviewer" class="p-button-outlined notifier-btn"
                                icon="pi pi-bell" iconPos="left" (click)="notifyReviewer()"
                                [disabled]="disabledControls">
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pd-0 p-0 pt-3">
                <i140-review-comment [dialogConfigData]="DynamicDialogConfigData" [disabledControls]="disabledControls">
                </i140-review-comment>
            </div>

            <!-- Below HTML Edit is enabled for petitioner / attorney with REVIEWER permission -->
            <div class="pd-0 p-0 pt-3 pb-3" *ngxPermissionsOnly="['PETITION_REVIEWER']">
                <div class="col-md-12 row pd-0 pt-3 add-comments">
                    <h5 class="w-100">Update the review status and enter comments for the entire I-140</h5>
                    <div class="col-md-7 p-0">
                        <label>Add Comments / Notes</label>
                        <textarea name="reviewNote" class="w-100" placeholder="Enter" [(ngModel)]="review.reviewNote"
                            [disabled]="disabledControls"></textarea>
                    </div>
                    <div class="col-md-7 p-0 processing-dropdown">
                        <label>Review </label>
                        <p-dropdown [options]="reviewStatusList" [(ngModel)]="review.reviewCode"
                            [disabled]="disabledControls" optionValue="stepReviewCode"
                            optionLabel="stepReviewDescription" placeholder="Select a Status"></p-dropdown>
                    </div>
                    <div class="col-md-7 p-0 pt-5 pb-4">
                        <button pButton type="button" label="Submit"
                            [ngClass]="disabledControls || disableSave ? 'btn btn-success  btn-success_disabled':'btn btn-primary'"
                            [disabled]="disabledControls || disableSave" (click)="submitReview()" type="button"
                            class="im-btn im-btn-primary im-btn-md">
                        </button>
                    </div>
                    <div class="col-12">
                        <gc-status-update [stepDetails]="stepDetails" type="NONE"[showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>